import { useEffect, useState } from 'react';
import ResizeObserver from 'resize-observer-polyfill';

type Entry = ResizeObserverEntry & {
  target: {
    onSizeChange?: (entry: unknown) => void;
  };
};

interface Viewport {
  height: number;
  width: number;
}

const resizeObserver = new ResizeObserver((entries) => {
  entries.forEach((entry: Entry) => {
    if (entry?.target?.onSizeChange) {
      entry.target.onSizeChange(entry.contentRect);
    }
  });
});

const useResizeObserver = () => {
  const [targetEl, setTargetEl] = useState<HTMLDivElement | HTMLElement | null>(null);
  const [current, setCurrent] = useState<number>();
  const [viewportSize, setViewportSize] = useState<Viewport>();

  const onSizeChange = (w: number) => {
    setCurrent(w);
    setViewportSize({ height: window.innerHeight, width: window.innerWidth });
  };

  const setRef = (ref: HTMLDivElement | HTMLElement | null) => {
    if (ref !== null) setTargetEl(ref);
  };

  useEffect(() => {
    if (targetEl === null) return;
    (targetEl as any).onSizeChange = onSizeChange;
    resizeObserver.observe(targetEl);
  }, [targetEl]);

  const result: [(ref: any) => void, number | undefined, Viewport | undefined] = [setRef, current, viewportSize];

  return result;
};

export default useResizeObserver;
